module.exports = __webpack_public_path__ + "static/media/masterIcon.e9bd8574.png";